import api from '../../../services/api';

export interface GenerateOrderInvoiceInput {
  orderId: string;
  type: string;
  totalAmount?: number;
  currency: string;
}

export async function fetchOrderInvoices(orderId: string): Promise<any[]> {
  const response = await api.get(`/invoices/order/${orderId}`);
  return response.data;
}

export async function generateOrderInvoice(payload: GenerateOrderInvoiceInput): Promise<void> {
  await api.post('/invoices/generate', payload);
}

export async function downloadOrderInvoicePdf(invoiceId: string): Promise<Blob> {
  const response = await api.get(`/invoices/${invoiceId}/pdf`, {
    responseType: 'blob',
  });

  return response.data;
}
